import { render, staticRenderFns } from "./nuevoPost.vue?vue&type=template&id=5e3763e8&scoped=true"
import script from "./nuevoPost.vue?vue&type=script&lang=js"
export * from "./nuevoPost.vue?vue&type=script&lang=js"
import style0 from "./nuevoPost.vue?vue&type=style&index=0&id=5e3763e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3763e8",
  null
  
)

export default component.exports